import { AccountingJournalCreateInput } from './../../../../types/src/mado/input-type/journal.create-input';
import { AccountingJournalUpdateInput } from './../../../../types/src/mado/input-type/journal.update-input';
import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    AccountingJournalGridObject, AccountingJournalObject,
} from '@libs/types/src/mado/object-type/journal.object';
import { filterFrag } from './types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class AccountingJournalGqlServiceV2 extends GqlServiceV2 {

    public getAccountingJournals(input: GridInput | null, frag: string) {
        return this.query<AccountingJournalGridObject>(
            `
                query($input: GridInput!) {
                    journal {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createAccountingJournal(input: AccountingJournalCreateInput, frag: string) {
        return this.mutate<AccountingJournalObject>(
            `
                mutation($input: AccountingJournalCreateInput!) {
                    journal {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateAccountingJournal(input: AccountingJournalUpdateInput, frag: string) {
        return this.mutate<AccountingJournalObject>(
            `
                mutation($input: AccountingJournalUpdateInput!) {
                    journal {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteAccountingJournal(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    journal {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
